// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","logo":"Header_logo__W53xq","logoAccent":"Header_logoAccent__a4EyC","tagline":"Header_tagline__6ZXaN"};